import * as Util from '../util/utilities'

export default {
    init() {
        const scrollcontrol = new ScrollMagic.Controller()
        const windowHalfX = window.innerHeight / 2

        if ($('[data-skewed]').length) {
            $('[data-skewed]').each(function () {
                const graphic = $(this).find('.slanted-image__graphic')

                /* :: Parallax
                ---------------------------------- */
                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            graphic,
                            2,
                            {
                                y: '-20%',
                            },
                            {
                                y: '30%',
                                ease: Linear.easeNone,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX,
                    '200%',
                    scrollcontrol,
                )
            })
        }
    },
}
